import React from "react";
import "./Home.css";

export const Stats = () => {
  const stats = [
    { value: "50+", label: "Projects Delivered" },
    { value: "10+", label: "Industries Served" },
    { value: "3X", label: "Avg ROI Delivered" },
  ];


  return (
    <section className="stats-section">
      <div>
     <div className="techstack-slider">
        <div className="techstack-track">
          {[...stats, ...stats].map((stat, index) => (
            <div className="stat-box" key={index}>
                <div>
              <div className="stat-value">{stat.value}</div>
              <span className="main-text-white">{stat.label}</span>
            </div>
             </div>
          ))}
        </div>
      </div>
      </div>
    </section>
  );
};